import React, { useEffect, useState } from 'react';
import { CheckCircle2, ShieldCheck, Lock, CreditCard, ArrowRight, Zap } from 'lucide-react';
const CHECKOUT_URL = 'https://profelisto.com.ar/checkouts/cn/hWNCutEqOFd1vepZz8kBRTjG/es-ar?_r=AQABfptd6HSysjRDmLVLhO27a3oaD_XEPmNjxvdeX-faZK8';
const PACK_PRICE = 27;
const INCLUDED = ['Los 12 Tomos completos — todos los niveles', 'Los 6 Bonus estratégicos incluidos', '+280 páginas y +120 ejercicios graficados en cancha', 'Acceso inmediato en PDF, para siempre'];
export function PricingSection() {
  const handleCheckout = () => {
    try {
      if (typeof window !== 'undefined' && (window as any).fbq) {
        ;
        (window as any).fbq('track', 'InitiateCheckout', {
          value: PACK_PRICE,
          currency: 'USD',
          content_name: 'Acceso Completo PADEL 360'
        });
      }
    } catch (_) {
      /* swallow */
    }
    window.location.href = CHECKOUT_URL;
  };
  // Countdown Timer Logic
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSecs = prev.seconds - 1;
        let newMins = prev.minutes;
        let newHours = prev.hours;
        if (newSecs < 0) {
          newSecs = 59;
          newMins -= 1;
        }
        if (newMins < 0) {
          newMins = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMins,
          seconds: newSecs
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div id="pricing" className="w-full bg-court-panel scroll-mt-10" data-id="element-126" data-mp="1rfhpqwpl0ohc">
      {/* SECTION 7 - PRECIO Y OFERTA */}
      <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-127" data-mp="jzuy7wrgzmnd">
        <div className="text-center mb-12" data-id="element-128" data-mp="fz1c98xl8hx4">
          <p className="text-cyan-400 font-heading font-bold text-xs sm:text-sm tracking-[0.2em] uppercase mb-4" data-id="element-129" data-mp="hi1anxsytyhr">
            ⏰ Precio de lanzamiento — Oferta por tiempo limitado
          </p>

          {/* Countdown */}
          <div className="flex justify-center gap-3 sm:gap-5 mb-5" data-id="element-130" data-mp="7kdcexw5i8uu">
            <TimeUnit value={timeLeft.hours} label="HS" data-id="element-131" data-mp="ciom98mg4jd2" />
            <div className="text-3xl font-bold text-white/20 mt-4" data-id="element-132" data-mp="ch3t9nfs58hb">:</div>
            <TimeUnit value={timeLeft.minutes} label="MIN" data-id="element-133" data-mp="3uvmtm0lkieh9" />
            <div className="text-3xl font-bold text-white/20 mt-4" data-id="element-134" data-mp="3i07gbp8aez4">:</div>
            <TimeUnit value={timeLeft.seconds} label="SEG" data-id="element-135" data-mp="3jbf4mlso6vi" />
          </div>

          <p className="text-red-400 font-bold text-sm sm:text-base" data-id="element-136" data-mp="3kzt5djyhkwjn">
            🔴 El precio sube cuando termina el contador
          </p>
        </div>

        {/* CHECKOUT CARD — SINGLE TICKET */}
        <div className="max-w-lg mx-auto bg-white/[0.04] rounded-3xl p-6 sm:p-9 border border-cyan-500/25 shadow-2xl shadow-cyan-500/5" data-id="element-137" data-mp="3bz3i54nakehj">
          <div className="text-center mb-7" data-id="element-138" data-mp="3g185xmr26gw9">
            <h3 className="text-2xl sm:text-3xl font-heading font-extrabold text-white mb-2" data-id="element-139" data-mp="2xc4od30yp7zn">
              Acceso Completo PADEL 360
            </h3>
            <p className="text-slate-400 text-sm sm:text-base font-medium" data-id="element-140" data-mp="2seczyizj0407">
              Un solo pago. Todos los Tomos y todos los Bonus incluidos.
            </p>
          </div>

          {/* What's included */}
          <ul className="space-y-3 mb-7" data-id="element-141" data-mp="3g9pf6fnaegmw">
            {INCLUDED.map(item => <li key={item} className="flex items-start gap-3" data-id="element-142" data-mp="3g7mgl782jf6k">
                <CheckCircle2 className="w-5 h-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-143" data-mp="3bactvzc2dhmf" />
                <span className="text-slate-300 text-sm sm:text-base" data-id="element-144" data-mp="3p0zhavcdjl37">
                  {item}
                </span>
              </li>)}
          </ul>

          {/* Price block */}
          <div className="rounded-2xl bg-cyan-500/10 border border-cyan-500/25 p-6 text-center mb-6" data-id="element-145" data-mp="2w4572cnxazj">
            <p className="text-slate-500 line-through text-base font-medium" data-id="element-146" data-mp="3u2otiebc24sv">
              USD 54
            </p>
            <p className="text-5xl sm:text-6xl font-heading font-extrabold text-white leading-none mt-1" data-id="element-147" data-mp="hxkqc4f63qte">
              USD <span className="text-cyan-400" data-id="element-148" data-mp="lxl6pultuc33">27</span>
            </p>
            <p className="text-slate-400 text-xs sm:text-sm font-medium mt-3" data-id="element-149" data-mp="qrpegg2x2o58">
              Pago único · Sin suscripciones · Acceso de por vida
            </p>
          </div>

          {/* CTA */}
          <button onClick={handleCheckout} className="w-full bg-cyan-500 hover:bg-cyan-400 text-slate-950 text-base sm:text-xl font-heading font-extrabold py-5 px-6 rounded-2xl shadow-2xl shadow-cyan-500/25 transition-all hover:scale-[1.02] flex items-center justify-center gap-3 uppercase tracking-wide" data-id="element-150" data-mp="3v5xn5nzkmbiy">
            SÍ, QUIERO MI ACCESO
            <ArrowRight className="w-5 h-5" data-id="element-151" data-mp="1jfl9zhgr2a0f" />
          </button>

          <p className="text-center text-slate-500 text-xs sm:text-sm mt-5" data-id="element-152" data-mp="1jhfu4tk75y3g">
            El sistema elegido por profesores de pádel de toda Latinoamérica
          </p>
        </div>

        {/* Trust badges grid */}
        <div className="max-w-lg mx-auto mt-9 grid grid-cols-2 gap-x-6 gap-y-4 text-slate-400 text-xs sm:text-sm font-medium" data-id="element-153" data-mp="33xdyghv8dtwb">
          <span className="flex items-center gap-2" data-id="element-154" data-mp="2z5m92ant9u7r">
            <Lock className="w-4 h-4 text-cyan-500" data-id="element-155" data-mp="2z41c6ee0xz6q" /> Pago seguro
          </span>
          <span className="flex items-center gap-2" data-id="element-156" data-mp="2u71643h6cwfm">
            <Zap className="w-4 h-4 text-yellow-400" data-id="element-157" data-mp="2q5zea7pl7mno" /> Acceso en 5 min
          </span>
          <span className="flex items-center gap-2" data-id="element-158" data-mp="2l63aa8gw3v84">
            <ShieldCheck className="w-4 h-4 text-cyan-500" data-id="element-159" data-mp="2l5beoxnalxhu" /> Garantía 7 días
          </span>
          <span className="flex items-center gap-2" data-id="element-160" data-mp="2g81ohfs2xhsy">
            <CreditCard className="w-4 h-4 text-cyan-500" data-id="element-161" data-mp="2b8yjtwg0hdli" /> Tarjeta ·
            Transferencia
          </span>
        </div>
      </section>

      {/* SECTION 8 - TABLA COMPARATIVA */}
      <section className="py-20 bg-court-night px-4 sm:px-6 lg:px-8 border-t border-white/5" data-id="element-162" data-mp="9hbqho8nd6lv">
        <div className="max-w-5xl mx-auto" data-id="element-163" data-mp="23xahn8gre0no">
          <h2 className="text-2xl sm:text-4xl font-heading font-extrabold text-center mb-12 text-white" data-id="element-164" data-mp="23wikvubfdwvt">
            ¿Cuánto cuesta <span className="text-cyan-400" data-id="element-165" data-mp="28pbqekepx98y">NO</span> tenerlo?
          </h2>

          <div className="overflow-x-auto pb-6" data-id="element-166" data-mp="1u0fiqogkpy8v">
            <table className="w-full min-w-[600px] border-collapse" data-id="element-167" data-mp="1yy7anih7xkd2">
              <thead data-id="element-168" data-mp="1yyh094ycppi8">
                <tr data-id="element-169" data-mp="1yvuy5ku8c27e">
                  <th className="w-1/3 p-4 text-left border-b border-white/10" data-id="element-170" data-mp="2mna21i1nmrkr"></th>
                  <th className="w-1/3 p-4 text-center text-red-400 font-heading font-bold text-base sm:text-lg border-b border-white/10" data-id="element-171" data-mp="2rmuynltcqnub">
                    Sin PADEL 360
                  </th>
                  <th className="w-1/3 p-4 text-center text-cyan-400 font-heading font-bold text-base sm:text-lg border-b border-white/10 bg-cyan-500/[0.07] rounded-t-xl" data-id="element-172" data-mp="2hop0nfao21uq">
                    Con PADEL 360
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-173" data-mp="16av0y8w5p716">
                <TableRow label="Planificación semanal" bad="2 horas armando desde cero" good="5 minutos. Todo listo." data-id="element-174" data-mp="16777f9qpokmg" />
                <TableRow label="Drills y secuencias" bad="Improvisados sin progresión" good="+120 secuencias graficadas por nivel" data-id="element-175" data-mp="ttafrzdsonr9" />
                <TableRow label="Grupos mixtos" bad="Sin sistema claro" good="Estructura para cada nivel y objetivo" data-id="element-176" data-mp="13n9fysub5xgk" />
                <TableRow label="Alumnos con lesiones" bad="Miedo a equivocarte" good="Protocolos listos para usar" data-id="element-177" data-mp="aybygrxx84ov" />
                <TableRow label="El domingo a la noche" bad="Ansiedad y estrés" good="Planilla maestra en 15 minutos" data-id="element-178" data-mp="kxb9gh65scf1" />
                <TableRow label="Progreso del alumno" bad="No se ve, no se mide" good="Checklist de graduación por tomo" data-id="element-179" data-mp="3oetdsemq31ap" />
                <TableRow label="Fidelidad del alumno" bad="Se va a los 3 meses" good="Se queda todo el año con un plan" isLast data-id="element-180" data-mp="37vw6u39ehzkh" />
              </tbody>
            </table>
          </div>

          <div className="text-center mt-12" data-id="element-181" data-mp="3lvnn6ane3s1n">
            <p className="text-xl sm:text-2xl font-heading font-bold text-cyan-400" data-id="element-182" data-mp="3lsrr6rv3rdfu">
              "El lunes puedes improvisar o entrar con todo resuelto. Tú
              decides."
            </p>
          </div>
        </div>
      </section>
    </div>;
}
function TimeUnit({
  value,
  label
}: {
  value: number;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-183" data-mp="8ghldfhu5hk4">
      <div className="bg-white/[0.06] border border-white/10 text-white text-3xl sm:text-5xl font-heading font-extrabold w-[70px] h-[70px] sm:w-24 sm:h-24 flex items-center justify-center rounded-2xl" data-id="element-184" data-mp="8hspxhj3utca">
        {value.toString().padStart(2, '0')}
      </div>
      <span className="text-slate-500 font-bold text-[11px] sm:text-xs mt-2 tracking-widest" data-id="element-185" data-mp="1sxqrwz6o2d1z">
        {label}
      </span>
    </div>;
}
function TableRow({
  label,
  bad,
  good,
  isLast = false
}: {
  label: string;
  bad: string;
  good: string;
  isLast?: boolean;
}) {
  return <tr data-id="element-186" data-mp="2gncnlcntya58">
      <td className={`p-5 text-white font-semibold text-sm sm:text-base ${!isLast ? 'border-b border-white/[0.07]' : ''}`} data-id="element-187" data-mp="2go4dq7ynrfo4">
        {label}
      </td>
      <td className={`p-5 text-center text-slate-500 text-sm sm:text-base ${!isLast ? 'border-b border-white/[0.07]' : ''}`} data-id="element-188" data-mp="2codf5i2w3v91">
        {bad}
      </td>
      <td className={`p-5 text-center text-slate-200 font-semibold text-sm sm:text-base bg-cyan-500/[0.07] ${!isLast ? 'border-b border-white/[0.07]' : 'rounded-b-xl'}`} data-id="element-189" data-mp="22vofdkgpc5tj">
        <div className="flex items-center justify-center gap-2" data-id="element-190" data-mp="2vk3fz1z36llc">
          <CheckCircle2 className="w-4 h-4 text-cyan-400 flex-shrink-0" data-id="element-191" data-mp="14v22no7kgra2" />{' '}
          {good}
        </div>
      </td>
    </tr>;
}